const validations = {
  name: {
    required: true,
    maxLength: 255
  },
  recipients: {
    required: true
  },
  title: {
    required: true
  },
  contents: {
    required: true
  },
  titleSms: {
    maxLength: 255
  }
};

export { validations };
